import {
    ICriterion,
    ICriterionData,
    CRITERION_NAME_MAX_LENGTH,
    CRITERION_DESCRIPTION_MAX_LENGTH
} from './index'

export class Criterion<T> implements ICriterion<T> {
    readonly id?: number
    name?: T
    label?: T
    description?: string
    value: boolean

    constructor (data?: ICriterionData<T>) {
        this.id = data?.id
        this.update(data);
        this.value = data?.value || false
    }

    update(data?: ICriterionData<T>): void {
        this.name = data?.name || this.name;
        this.label = data?.label || this.name;
        this.description = data?.description || this.description;
    }

    validate(): boolean {
        return (this.validateName() && this.validateDescription())
    }

    validateName(): boolean {
        let name = this.name
        return !!name && (name as any).length <= CRITERION_NAME_MAX_LENGTH
    }

    validateDescription(): boolean {
        let desc = this.description
        return !desc || desc.length <= CRITERION_DESCRIPTION_MAX_LENGTH
    }

    get key(): string {
        let id = this.id;
        return (id ? (id + '-') : '') + this.name;
    }
}
